import { ReactComponent as StarIcon } from "../../../../assets/icons/star.svg";
import { ReactComponent as HalfStarIcon } from "../../../../assets/icons/half-start.svg";

const STAR_COUNT = 5;

export function Rating({ rating, className = "" }) {
  const halfRating = Number(rating) % 1;
  const hasHalfStar = halfRating >= 0.25;
  return (
    <div className="flex items-center gap-1">
      {Array.from({ length: rating }).map((_, index) => (
        <StarIcon
          key={index}
          className={`w-4 h-4 ${className}`}
          //   className={`${
          //     rating <= index + 1
          //       ? "[&_path]:fill-white [&_path]:stroke-[rgba(221, 221, 221, 0.40)]"
          //       : ""
          //   }`}
        />
      ))}
      {hasHalfStar && <HalfStarIcon className={`mt-1 w-4 h-4 ${className}`} />}
    </div>
  );
}
